import { fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { getAuth } from '../getAuth';
export const getAuthAsPojo = createSelector([getAuth], auth => fromJS(auth).toJS());